import { ContentTypeEnum } from '@lyearn-team/reporting-library';

import { getOffer } from '../LocalStore';

function getContentId(state) {
  switch (state.contentType) {
    case ContentTypeEnum.OFFER:
    case ContentTypeEnum.CURRICULUM_OFFER:
    case ContentTypeEnum.CHECKPOINT:
    case ContentTypeEnum.ILT:
      return state.contentId;
    default:
      if (!state.rootContentId_contentId) {
        return state.contentId;
      }
      return state.rootContentId_contentId.split('_')[0];
  }
}

export default async function addVersionId(document) {
  if (document.versionId) {
    return document;
  }
  const contentId = getContentId(document);
  const offer = await getOffer(contentId);
  if (!offer || !offer.latestVersionId) {
    return document;
  }
  return {
    ...document,
    versionId: offer.latestVersionId
  };
}
